










































import Enumerable from "linq";
import { Component, Mixins, Emit } from "vue-property-decorator";
import { DateEditableMixin } from "./mixins";
import { DomainRegistry } from "../../../domain";
import { Holiday } from "../../../domain/holiday";
import FixedLoading from "../../system/FixedLoading.vue";

@Component({
  components: {
    FixedLoading,
  }
})
export default class DateCalendarSelector extends Mixins(DateEditableMixin) {
  $refs!: {
    table: HTMLTableElement;
  };

  async created() {
    await this.setHolidays();
    this.isLoaded = true;
  }

  data(): any {
    return {
      dayOfWeeks: ["日", "月", "火", "水", "木", "金", "土"],
      isLoaded: false,
      holidays: [],
    };
  }
  dayOfWeeks: string[];
  isLoaded: boolean;
  holidays: Date[];

  get calendar(): Date[][] {
    const offset = (new Date(this.year, this.month - 1, 0)).getDay();
    return Enumerable.range(0, 6)
      .select(w => this.toWeekDays(w * 7 - offset))
      .toArray();
  }

  private toWeekDays(offset: number): Date[] {
    return Enumerable.range(0, 7)
      .select(d => new Date(this.year, this.month - 1, offset + d))
      .toArray();
  }

  toStyle(day: Date): any {
    const dayTime = day.getTime();
    return {
      selected: (dayTime === this.toDate(this.editingSource).getTime()),
      today: (dayTime === this.toDate(new Date()).getTime()),
      otherMonth: (day.getMonth() !== (this.month - 1)),
      holiday: this.holidays.some(x => !!x && dayTime === x.getTime()),
    };
  }

  toDate(source: Date): Date {
    return new Date(
      source.getFullYear(),
      source.getMonth(),
      source.getDate()
    );
  }

  daySelected(day: Date): void {
    this.editingSource = day;
  }

  @Emit("doubleClick")
  dayDoubleClicked(): void {}

  async getHolidays(): Promise<Holiday[]> {
    try {
      const repository = DomainRegistry.holiday.getHolidayRepository();
      return await repository.getAllEntities();
    } catch (e) {
      this.$error(
        "祝日情報取得失敗",
        "祝日情報を取得できませんでした。",
        e
      );
    }
  }

  async setHolidays(): Promise<void> {
    const holidays = await this.getHolidays();
    this.holidays = Enumerable.from(holidays)
      .where(h => !h.isDeleted)
      .select(h => h.targetDate)
      .toArray();
  }
}
